import {SelectInput} from "../../../shared/dropdown/shared/select-input.class";

export enum GroupTypeEnum {
    SWA,
    LIST,
    WeighingSystem
}
export function getGroupTypeString(groupType: GroupTypeEnum): string {
    switch (groupType) {
        case GroupTypeEnum.SWA:
            return 'SWA (SWA aktiv)'
        case GroupTypeEnum.LIST:
            return 'Freie Geräte (SWA inaktiv)'
        case GroupTypeEnum.WeighingSystem:
            return 'Wiegeanlage'
    }
}

export function getGroupTypeSelect(): SelectInput[] {
    return [
        {name: getGroupTypeString(GroupTypeEnum.SWA), id: 0} as SelectInput,
        {name: getGroupTypeString(GroupTypeEnum.LIST), id: 1} as SelectInput,
        {name: getGroupTypeString(GroupTypeEnum.WeighingSystem), id: 2} as SelectInput
    ];
}
